import { render, staticRenderFns } from "./jobTreeQuestionNode.vue?vue&type=template&id=068f0a6e&scoped=true"
import script from "./jobTreeQuestionNode.vue?vue&type=script&lang=js"
export * from "./jobTreeQuestionNode.vue?vue&type=script&lang=js"
import style0 from "./jobTreeQuestionNode.vue?vue&type=style&index=0&id=068f0a6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068f0a6e",
  null
  
)

export default component.exports